import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {FilterCategory} from "@core/enumerations/filter-category.enum";
import {ReportGroup} from "@core/models/report-group.model";
import {ReportGroupService} from "@core/services/api/report-group.service";

const REPORT_PERIOD_FILTER_KEY = 'ReportPeriodFilter';
const REPORT_COSTCENTER_FILTER_KEY = 'ReportCostcenterFilter';

@Injectable({
  providedIn: 'root'
})
export class AppStore {
  reportGroups$: BehaviorSubject<ReportGroup[] | null> = new BehaviorSubject<ReportGroup[] | null>(null);
  activeReportId$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);

  constructor(
    private readonly reportGroupService: ReportGroupService
  ) {
  }

  fetchReportGroups() {
    this.reportGroupService.getList().subscribe(reportGroups => this.reportGroups$.next(reportGroups));
  }

  hasReportFilter(filterCategory: FilterCategory) {
    const key = this.determineKey(filterCategory);
    return localStorage.getItem(key) !== null;
  }

  setReportFilter(filterCategory: FilterCategory, filter: string[]) {
    const key = this.determineKey(filterCategory);
    localStorage.setItem(key, JSON.stringify(filter));
  }

  removeOldCostcenters(costcenters: string[]) {
    const cachedCostcenters = this.getReportFilter(FilterCategory.costcenter)!;
    const newCostcenters = cachedCostcenters.filter(c => costcenters.includes(c));
    this.setReportFilter(FilterCategory.costcenter, newCostcenters);
  }

  getReportFilter(filterCategory: FilterCategory): string[] | null {
    if (!this.hasReportFilter(filterCategory)) {
      return null;
    }

    const key = this.determineKey(filterCategory);
    return JSON.parse(localStorage.getItem(key)!);
  }

  clearReportFilters() {
    localStorage.removeItem(REPORT_PERIOD_FILTER_KEY);
    localStorage.removeItem(REPORT_COSTCENTER_FILTER_KEY);
  }

  private determineKey(filterCategory: FilterCategory) {
    switch (filterCategory) {
      case FilterCategory.period:
        return REPORT_PERIOD_FILTER_KEY;
      case FilterCategory.costcenter:
        return REPORT_COSTCENTER_FILTER_KEY;
      default:
        throw new Error('Unsupported filter category');
    }
  }
}
